import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  getLayerId,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { setOriginalLayers } from '.';

export const grids: WorkspaceItem = setOriginalLayers({
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'grids',
  dataType: 'grids',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Grids',
  description: 'Canadian and US grids',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: {
    layers: [
      {
        id: getLayerId('grids', 'grids', 0),
        name: 'Grids',
        type: LayerType.Polygon,
        style: { color: 'transparent' },
        source: {
          type: 'geojson',
          data: { type: 'FeatureCollection', features: [] },
        },
        sourceLayer: undefined,
        renderAsPoints: true,
      },
    ],
  },
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/grids',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: ['internal_id', 'geometry'],
  },
  detailsSource: 'local',
  query: buildQuery({
    id: 'grids',
    dataType: 'grids',
  }),
  module: 'grids',
  ...createInitInternalState({ isVisualized: false }),
});
